import { authContext } from './adal'
import axios from 'axios'

const initialState = {
    loading: true,
    user: null
}

export default function reducer(state = initialState, action = {}) {

    switch (action.type) {

        case 'AUTH_FETCH_SCUCESS':
            return Object.assign({}, state, { loading: false, user: action.user })

        case 'AUTH_FETCH_FAIL':
            return Object.assign({}, state, { loading: false, user: null })

        case 'AUTH_LOGOUT':
            return Object.assign({}, state, { loading: false, user: null })

        case 'SAVE_LOGIN_INFO_SUCCESS':
            return { ...state }

        case 'SAVE_LOGIN_INFO_FAIL':
            return Object.assign({}, state, { user: null })

        default:
            return state;
    }
}

export const actions = {

    fetchSuccess(user) {
        return { type: 'AUTH_FETCH_SCUCESS', user }
    },

    fetchFail() {
        return { type: 'AUTH_FETCH_FAIL' }
    },

    logOut() {
        return { type: 'AUTH_LOGOUT' }
    },

    saveLoginInfoSuccess() {
        return { type: 'SAVE_LOGIN_INFO_SUCCESS' }
    },

    saveLoginInfoFail() {
        return { type: 'SAVE_LOGIN_INFO_FAIL' }
    }
}

export const sides = {

    fetch() {

        return dispatch => {

            authContext.handleWindowCallback();
            const user = authContext.getCachedUser();

            if (user) {
                dispatch(actions.fetchSuccess(user))
            }
            else {
                dispatch(actions.fetchFail())
            }
        }
    },

    login() {
        return dispatch => {

            authContext.login();
        }
    },

    logout() {
        return dispatch => {

            authContext.logOut();
            dispatch(actions.logOut())
        }
    },

    saveLoginInfo(user) {
        return dispatch => {
            dispatch(actions.saveLoginInfoSuccess());

            /*
            const userEmail = user.profile.email || user.userName;

            axios.get(`/users?upn=${userEmail}`).then(result => {
                if (result.data.length > 0) {
                    dispatch(actions.saveLoginInfoSuccess())
                } else {
                    dispatch(actions.saveLoginInfoFail())
                }
            })
            .catch(getUserReason => {
                dispatch(actions.saveLoginInfoFail())
            })
            */
        }
    }
}
